import styled from 'styled-components';

import { Button, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const StyledButton = styled(Button)`
  padding: 0;
  width: ${({ theme }) => theme.x4spacePx}px;
  height: ${({ theme }) => theme.x4spacePx}px;

  transform: ${({ theme }) =>
    `translate(-${theme.x1spacePx}px, -${theme.x1spacePx}px)`};
`;

export const StyledList = styled(Grid)`
  list-style-type: disc;
  padding-left: ${({ theme }) => theme.x3spacePx}px;
  padding-right: ${({ theme }) => theme.x2spacePx}px;
`;
